export const sizes: { [key: string]: string } = {
	'x-small': 'var(--epods--icon-x-small)',
	small: 'var(--epods--icon-small)',
	medium: 'var(--epods--icon-medium)',
	large: 'var(--epods--icon-large)',
	'x-large': 'var(--epods--icon-x-large)',
};

export const colors: { [key: string]: string } = {
	validated: 'var(--epods--color-signal-success-icon)',
	error: 'var(--epods--color-signal-error-icon)',
	warning: 'var(--epods--color-signal-warning-icon)',
	information: 'var(--epods--color-signal-info-icon)',
};

export const clearIconStyle = {
	paddingTop: '0',
	paddingBottom: '0',
	paddingLeft: '0',
	paddingRight: '0',
};

